<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            <h5>{{ conversationName }}</h5>
            <small v-if="conversation.created_at" class="text-muted"> {{ $t('chat.created_at') }} {{ $dateFormatter(conversation.created_at, locale, true) }} </small>
          </div>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
          </div>
        </div>
        <div class="modal-body">
          <div v-if="!isManaging" class="row">
            <div class="col-10">
              <Input
                  inputClass="form-control form-control-sm"
                  name="participator-input-search"
                  :isInputGroup="true"
                  :placeholder="$t('label.search')"
                  v-model="search"
              >
                <template #rightAddon>
                  <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle me-3">
                    <i class="fa fa-search"></i>
                  </span>
                </template>
              </Input>
            </div>
            <div v-if="iAmAdmin" class="col-2 justify-content-center align-items-center mt-2 mb-5">
              <button @click.prevent="toggleAddMemberModal" class="btn btn-primary btn-icon">
                <i class="bi bi-plus fs-2"></i>
              </button>
            </div>
            <div v-if="iAmAdmin && conversation.group_type !== 'PUBLIC'" class="d-flex justify-content-between align-items-center">
              <span class="fs-4 text-muted fw-bold"> {{ conversationUser.length.toString().padStart(2, '0') }} {{ $t("chat.participators") }} </span>
              <Button type="new" btn-class="btn-sm btn-outline-primary" size="7px 30px" btn-text="chat.button.manage" @click.prevent="manageParticipator"/>
            </div>
          </div>
          <div v-else class="row">
            <div class="d-flex justify-content-between align-items-center">
              <h2> {{ $t('chat.manageMember') }} </h2>
              <Button type="new" btn-class="btn-sm btn-outline-primary" size="7px 30px" btn-text="chat.button.complete" @click.prevent="manageParticipator"/>
            </div>
          </div>
          <div class="d-flex flex-column h-400px scroll-y">
            <h5 class="my-4"> {{ $t('chat.groupAdmin') }} </h5>
            <UserRowCard v-for="admin in conversationAdmins" :user="admin" :key="admin.participator_id" />
            <h5 class="my-4"> {{ $t('chat.members') }} </h5>
            <UserRowCard
                v-for="member in conversationMembers"
                :user="member"
                :key="member.participator_id"
                :show-action-btn="isManaging && iAmAdmin"
                :action-btn="() => removeMember(member)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <AddMemberModal id="add-member-modal" @close-modal="toggleModal" :conversation-id="conversation.id" />
</template>

<script setup>
import {ref, defineEmits, defineProps, computed} from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import Button from "@/components/Button"
import {useRouter} from "vue-router";
import AddMemberModal from "@/Modules/Chat/components/modals/AddMemberModal.vue";
import {$dateFormatter} from "@/mixins/Helpers";
import {useLocales} from "@/composables/locales";
import UserRowCard from "@/Modules/Chat/components/UserRowCard.vue";
import {useSwal} from "@/composables/useSwal";

const store = useStore()
const router = useRouter()
const {showSwal} = useSwal()

const { locale } = useLocales()

const emits = defineEmits(['afterUpdate', 'afterCreate'])
const props = defineProps({
  id: { type: String, required: true},
  conversation: { type: Object, default: () => ({

    })
  }
})


const search = ref('')
const isManaging = ref(false)
const processing = ref(false)
const loading = ref(true)

const currentUser = computed(() => store.getters['user/currentUser'])
const conversationName = computed(() => props.conversation.name)
const conversationUser = computed(() => store.getters['chat/getCurrentConversationUsers'])
const conversationUserFiltered = computed(() => {
  console.log(conversationUser.value)
  if(!conversationUser.value?.length) return []
  return conversationUser.value.filter(user => user.participator.fullname?.toLocaleLowerCase()?.includes(search.value.toLocaleLowerCase()))
})
const conversationAdmins = computed(() => {
  if(!conversationUserFiltered.value.length) return []
  return conversationUserFiltered.value.filter(user => user.is_admin)
})
const conversationMembers = computed(() =>  {
  if(!conversationUserFiltered.value.length) return []
  return conversationUserFiltered.value.filter(user => !user.is_admin)
})
const iAmAdmin = computed(() => conversationAdmins.value.find(p => p.participator_id === currentUser.value.id) || false)

function toggleModal(){
  $('#'+props.id).modal('toggle')
}

function toggleAddMemberModal(){
  toggleModal()
  $('#add-member-modal').modal('toggle')
}

function manageParticipator() {
  isManaging.value = !isManaging.value
}

function removeMember (member) {
  showSwal(
      i18n.global.t('swal.title'),
      i18n.global.t('chat.swal.remove_member')
  ).then( async (result) => {
    if (result.value) {
      store.dispatch('chat/removeGroupMembers', {
        users: [member.participator_id],
        conversation_id: props.conversation.id
      })
          .then(() => {
            window.toastr['success'](i18n.global.t("chat.notification.member_removed"))

          })
    }
  })
}



</script>